import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createObjectCollectionReduceObject } from '../../../../../common/reducers/objectCollection/reducer';

import userGetByIdSaga from './sagas/userGetByIdSaga';

export default [
  // Collection
  ...createCombineMapItem(
    'userCollection',
    createObjectCollectionReduceObject,
    [userGetByIdSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/collections/reducersMap.js